import { render, staticRenderFns } from "./PostOfficesList.vue?vue&type=template&id=4eedc540&"
import script from "./PostOfficesList.vue?vue&type=script&lang=js&"
export * from "./PostOfficesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports